// 카테고리 그리드 화면.
// 작업계획서 4.3 (14): 관리자가 등록한 카테고리를 그리드 버튼 배열로 표시.

import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { listCategories } from "@/features/catalog/catalogApi.ts";
import { imageUrl } from "@/features/catalog/imageUrl.ts";

// 카테고리 목록 화면.
export default function CategoryPage() {
  const { data: categories = [], isLoading } = useQuery({
    queryKey: ["catalog", "categories"],
    queryFn: listCategories,
  });

  return (
    <div className="flex flex-col">
      <header className="sticky top-[var(--safe-top)] z-10 border-b border-ink-200 bg-white px-4 py-3">
        <h1 className="text-lg font-bold">카테고리</h1>
      </header>
      <main className="mx-auto w-full max-w-screen-sm px-4 py-4">
        {isLoading ? (
          <div className="grid grid-cols-3 gap-3">
            {Array.from({ length: 6 }).map((_, i) => (
              <div key={i} className="aspect-square animate-pulse rounded-lg bg-ink-100" />
            ))}
          </div>
        ) : categories.length === 0 ? (
          <p className="rounded-md border border-dashed border-ink-300 p-8 text-center text-sm text-ink-600">
            카테고리가 곧 등록됩니다.
          </p>
        ) : (
          <ul className="grid grid-cols-3 gap-3">
            {categories.map((c) => {
              const iconUrl = imageUrl(c.iconImageKey);
              return (
                <li key={c.id}>
                  <Link
                    to={`/category/${c.id}`}
                    className="flex flex-col items-center gap-2 rounded-lg border border-ink-200 bg-white p-3 hover:border-ink-400"
                  >
                    <div className="aspect-square w-full overflow-hidden rounded-lg bg-ink-100">
                      {iconUrl ? (
                        <img src={iconUrl} alt="" loading="lazy" decoding="async" className="h-full w-full object-cover" />
                      ) : null}
                    </div>
                    <span className="line-clamp-1 text-center text-sm">{c.name}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        )}
      </main>
    </div>
  );
}
